// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as CurrencyMajorMinorMapper from "../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";

function getVm(free_kms, price_per_min) {
  return {
          price_per_min: Currency.toString(CurrencyMajorMinorMapper.baseToCurrency(price_per_min)),
          price_per_km: "0",
          start_distance: "0",
          end_distance: String(free_kms)
        };
}

export {
  getVm ,
  
}
/* No side effect */
